import { getFinancialBill, getFinancialBillV2 } from "@/apis/company/bill.js";

/*
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
  set_financial_bill_obj: "billMgt/set_financial_bill_obj",
  set_financial_bill_list: "billMgt/set_financial_bill_list",
  set_financial_bill_list_total_page:
    "billMgt/set_financial_bill_list_total_page",
  set_mode: "billMgt/set_mode",
  set_filter_query: "billMgt/set_filter_query",
  set_filter_word: "billMgt/set_filter_word",
  set_filter_result: "billMgt/set_filter_result",
  set_filter_default: "billMgt/set_filter_default",
  set_loading: "billMgt/set_loading"
};

// count state 必須是 Object
const state = {
  financialBillObj: null,
  financialBillList: null,
  filterQuery: {
    bindAccountType: "CONTRACT_BILL",
    billStatus: null,
    groupCode: null,
    landlordCid: null,
    fromDueDate: null,
    toDueDate: null,
    city: null,
    district: null,
    fromAmt: null,
    toAmt: null,
    keyword: null,
    // dueDateOrder: "DESC",
    order: "DESC",
    orderBy: "PAY_DATE",
    page: 1
  },
  totalPage: 0,
  filterWord: "",
  filterResult: [],
  mode: null,
  isDefault: false,
  isLoading: false
};

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
  GET_BIZ_BILL_MGT_LIST: state => {
    return state.financialBillList ? state.financialBillList : [];
  },
  GET_BIZ_BILL_MGT_FILTER_RESULT: state => {
    return state.filterResult;
  },
  GET_BIZ_BILL_MGT_LIST_TOTAL_PAGE: state => {
    return state.totalPage;
  },
  GET_BIZ_BILL_MGT_RECEIVABLE: state => {
    let list = state.financialBillObj ? state.financialBillObj.billList : [];
    let amount = 0;
    let total = 0;

    for (let i = 0; i < list.length; i++) {
      const element = list[i];
      amount += element.receivableAmount;
      total += 1;
    }
    let data = {
      amount: amount,
      count: total
    };
    return data;
  },
  GET_BIZ_BILL_MGT_RECEIVED: state => {
    let list = state.financialBillObj ? state.financialBillObj.billList : [];
    let amount = 0;
    let total = 0;

    for (let i = 0; i < list.length; i++) {
      const element = list[i];
      if (element.billStatus === "COMPLETELY_PAID") {
        amount += element.receivableAmount;
        total += 1;
      }
    }
    let data = {
      amount: amount,
      count: total
    };
    return data;
  },
  GET_BIZ_BILL_MGT_UNPAID: state => {
    let list = state.financialBillObj ? state.financialBillObj.billList : [];
    let amount = 0;
    let unpaidTotal = 0;
    let overDueTotal = 0;

    for (let i = 0; i < list.length; i++) {
      const element = list[i];
      if (element.billStatus === "UNPAID" || element.billStatus === "OVERDUE") {
        amount += element.receivableAmount;
        if (element.billStatus === "UNPAID") {
          unpaidTotal += 1;
        } else if (element.billStatus === "OVERDUE") {
          overDueTotal += 1;
        }
      }
    }
    let data = {
      amount: amount,
      count: unpaidTotal + overDueTotal,
      unpaidCount: unpaidTotal,
      overdueCount: overDueTotal
    };
    return data;
  },
  GET_BIZ_BILL_MGT_PAYMENT_RATE: state => {
    return state.financialBillObj ? state.financialBillObj.paymentRate : 0;
  },
  GET_BIZ_BILL_MGT_MODE: state => {
    return state.mode;
  },
  GET_BIZ_BILL_MGT_FILTER_QUERY: state => {
    return state.filterQuery;
  },
  GET_BIZ_BILL_MGT_FILTER_WORD: state => {
    return state.filterWord;
  },
  GET_BIZ_BILL_MGT_FILTER_DEFAULT: state => {
    return state.isDefault;
  }
};

// actions 也是以 Object 形式建構。
const actions = {
  getBizBillMgtList({ commit }) {
    return new Promise((resolve, reject) => {
      commit(types.set_loading, true);
      getFinancialBill()
        .then(res => {
          commit(types.set_loading, false);
          if (res.data.status == "SUCCESS") {
            console.log(res);
            commit(types.set_financial_bill_obj, res.data.result);
            resolve();
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getBizBillMgtListV2({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit(types.set_loading, true);
      getFinancialBillV2(state.filterQuery)
        .then(res => {
          commit(types.set_loading, false);
          if (res.data.status == "SUCCESS") {
            console.log(res);
            commit(types.set_financial_bill_list, res.data.result.content);
            commit(
              types.set_financial_bill_list_total_page,
              res.data.result.totalPages
            );
            resolve();
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  setBizBillMgtFilterQuery({ commit, state }, value) {
    return new Promise((resolve, reject) => {
      commit(
        types.set_filter_query,
        Object.assign({}, state.filterQuery, value)
      );
      resolve();
    });
  },
  setBizBillMgtFilterWord({ commit }, value) {
    return new Promise((resolve, reject) => {
      commit(types.set_filter_word, value);
      resolve();
    });
  },
  setBizBillMgtFilterDefault({ commit, state }) {
    return new Promise((resolve, reject) => {
      let filter = {
        bindAccountType: "CONTRACT_BILL",
        groupCode: null,
        landlordCid: null,
        fromDueDate: null,
        toDueDate: null,
        city: null,
        district: null,
        fromAmt: null,
        toAmt: null,
        keyword: null,
        // dueDateOrder: "DESC",
        orderBy:"PAY_DATE",
        order:"DESC",
        page: 1
      };
      commit(
        types.set_filter_default,
        Object.assign({}, state.filterQuery, filter)
      );
      resolve();
    });
  },
  setBizBillMgtFilterResult({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit(types.set_filter_result, data);
      resolve();
    });
  }
  // setHouseMgtMode ( {commit}, data ) {
  //     return new Promise((resolve, reject) => {
  //         commit(types.set_mode, data);
  //         resolve()
  //     })
  // }
};

// mutations
const mutations = {
  [types.set_financial_bill_obj](state, data) {
    state.financialBillObj = data;
  },
  [types.set_financial_bill_list](state, data) {
    state.financialBillList = data;
  },
  [types.set_financial_bill_list_total_page](state, data) {
    state.totalPage = data;
  },
  [types.set_mode](state, data) {
    state.mode = data;
  },
  [types.set_filter_word](state, data) {
    state.filterWord = data;
    state.isDefault = false;
  },
  [types.set_filter_query](state, data) {
    state.filterQuery = data;
    state.isDefault = false;
  },
  [types.set_filter_result](state, data) {
    state.filterResult = data;
  },
  [types.set_filter_default](state, data) {
    state.filterQuery = data;
    setTimeout(() => {
      state.isDefault = true;
    }, 100);
  },
  [types.set_loading](state, data) {
    state.isLoading = data;
  }
};

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/bussiness/financialReport/billMgt.js